import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import type { UsersSignInPostOptions } from 'api/users/signIn';

export function resetAuthenticatorApi(path: string) {
  return {
    path,
    POST: ({ email, password, otp }: UsersSignInPostOptions) =>
      api.post<JsonApiResponseSingle>(path, {
        email,
        password,
        otp_code_token: otp,
      }),
  };
}
